import { createElement } from "@max/max";
import { getFullScreenSize } from "@/utils/layout";
import ModalBaseContainer from '@max/leez-modal-base-container';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import TopView from '@max/leez-top-view';
import ModalBottomBtn from "../modal-bottom-button";
import './index.scss';
export default function CreatedPopup(props) {
    const { fullScreenHeight } = getFullScreenSize();
    if (!props.visible) {
        return null;
    }
    return <TopView>
      <ModalBaseContainer visible={props.visible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
        
        <LImage source={{
        uri: 'https://p0.meituan.net/ingee/e9cddd2264bef0aef4cb3f83c344df44362742.png'
    }} style={{
        width: '750rpx',
        height: '762rpx',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }}>
          
          <View className="created-popup-card">
            <Text className="created-popup-title">你是队长</Text>
            <Text className="created-popup-description">快去邀人打Call，冲榜赢免单！</Text>

            
            <View style={{
        marginTop: '85rpx'
    }}>
              <ModalBottomBtn buttonText={'邀好友来打Call'} onPress={props.onInviteCall}/>
            </View>
          </View>
        </LImage>

        
        <LImage onPress={props.onClose} source={{
        uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
    }} style={{
        width: '48rpx',
        height: '48rpx',
        marginTop: '60rpx'
    }} className="created-popup-close-btn"/>
      </ModalBaseContainer>
    </TopView>;
}
